"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Deck = void 0;
const CryptoProvider_1 = require("../util/CryptoProvider");
class Deck {
    constructor() {
        this.cards = this.buildDeck();
    }
    buildDeck() {
        let newDeck = [];
        Deck.suits.forEach((suit) => {
            Deck.values.forEach((value) => {
                newDeck.push(value + suit);
            });
        });
        return newDeck;
    }
    burnOne() {
        this.cards.splice(0, 1);
    }
    rebuild() {
        this.cards = this.buildDeck();
    }
    shuffleFisherYates() {
        for (let i = 0; i < this.cards.length; i++) {
            const j = this.getRandomInt(i + 1);
            [this.cards[i], this.cards[j]] = [this.cards[j], this.cards[i]];
        }
    }
    shuffleSattolo() {
        for (let i = this.cards.length; (i -= 1);) {
            const j = this.getRandomInt(i);
            [this.cards[i], this.cards[j]] = [this.cards[j], this.cards[i]];
        }
    }
    validCard(card) {
        if (card.length != 2) {
            return false;
        }
        if (Deck.values.filter((value) => card.slice(0, 1).toLowerCase() === value.toLowerCase()).length == 0) {
            return false;
        }
        if (Deck.suits.filter((suit) => card.slice(1, 2).toLowerCase() === suit)
            .length == 0) {
            return false;
        }
        return true;
    }
    setCryptoProvider(provider) {
        this.cryptoProvider = provider;
    }
    getRandomInt(size) {
        if (!this.cryptoProvider) {
            this.cryptoProvider = new CryptoProvider_1.DefaultCryptoProvider();
        }
        return this.cryptoProvider.randomInt(size);
    }
}
exports.Deck = Deck;
Deck.suits = ['s', 'h', 'd', 'c'];
Deck.values = [
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'T',
    'J',
    'Q',
    'K',
    'A',
];
//# sourceMappingURL=Deck.js.map